import React from "react";
import { Education } from "../components/Education";
import { Layout } from "../components/Layout";

const EducationPage = () => {
  return (
    <Layout>
      <Education />
    </Layout>
  );
};

export default EducationPage;
